import React, { Component } from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';

export default class ScrollTo extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: 'aboutRef' };
    }

    execFunc = (func, attr) => {
        this.setState({ selected: attr }, () => func(attr));
    }

    render() {
        const { scrollComponents, aboutScrollFunc } = this.props;
        const { selected } = this.state;

        return (
            <div>
                {scrollComponents && (
                    <nav>
                        <button className={classnames(['font-accent', { 'selected': selected === 'aboutRef' }])}
                            onClick={() => this.execFunc(aboutScrollFunc, 'aboutRef')}>
                            <I18n k="user_page_perseus.seller_profile.nav.about"/>
                        </button>

                        {scrollComponents.map((comp) => (
                            <button key={comp.ref}
                                className={classnames(['font-accent', { 'selected': selected === comp.ref }])}
                                onClick={() => this.execFunc(comp.scrollFunc, comp.ref)}>
                                <I18n k={`user_page_perseus.seller_profile.nav.${comp.title}`}/>
                            </button>
                        ))}
                    </nav>
                )}
            </div>
        );
    }
}
